import React from 'react';

const threads = [
  {
    id: 'fluxtrade',
    label: 'FluxTrade',
    question: 'Tell me about FluxTrade',
    detail: 'market data → decisions → simulation → validation'
  },
  {
    id: 'research',
    label: 'Limited-data AI research',
    question: 'Tell me about your NEC research',
    detail: 'weak supervision + GPT-4 rules + GIS'
  },
  {
    id: 'interfaces',
    label: 'Data tools and interfaces',
    question: 'Tell me about Deutsche Börse',
    detail: 'validation frameworks + usable workflows'
  }
];

function EvidenceWeave({ activeThread, onExplore }) {
  return (
    <nav className="evidence-weave" aria-label="Explore my work">
      <div className="evidence-weave__heading">
        <p className="eyebrow">Explore my work</p>
        <span>Pick a topic, then ask a follow-up.</span>
      </div>
      <ul>
        {threads.map((thread) => {
          const isActive = activeThread === thread.id;
          return (
            <li key={thread.id} className={isActive ? 'is-active' : ''}>
              <button
                type="button"
                aria-pressed={isActive}
                onClick={() => onExplore(thread.question, thread.id)}
              >
                <span className="evidence-weave__marker" aria-hidden="true" />
                <span className="evidence-weave__copy">
                  <strong>{thread.label}</strong>
                  <small>{thread.detail}</small>
                </span>
                <span className="evidence-weave__action" aria-hidden="true">
                  Explore ↗
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default EvidenceWeave;
